import { Link } from "gatsby"
import React, { useState } from "react"
import { Button, Modal } from 'react-bootstrap';
import './RightBlock.scss'
import RentersRightBillForm from "../../ValuationForm/ValuationInfo/RentersRightBillForm"
const StaticRenterBlock = () => {

  const [showPopup, setShowPopup] = useState(false)

  const handleOpen = () => setShowPopup(true)
  const handleClose = () => setShowPopup(false)

  return (
    <React.Fragment>
      <div className="right-block static-page-ryt">

        {/* ★ Button that opens popup */}
        <div className="contact-details p-0">
          <Button className="btn btn-primary" onClick={handleOpen}>
            Download Compliance Checklist
          </Button>
        </div>

        <div className="appraisal-bar">
          <div className="left-block">
            <h2>What will the Renters’ Rights Act mean for me?</h2>
            <p>
              New rules take effect on 1st May 2026. Get a clear, expert compliance check to ensure you’re fully prepared.
            </p>
          </div>
          <div className="right-block static-render">
            <Button className="btn btn-primary" onClick={handleOpen}>
              CHECK YOUR COMPLIANCE
            </Button>
          </div>
        </div>
      </div>

      {/* ★ Popup Modal with the Form */}
      <Modal show={showPopup} onHide={handleClose}  centered className="renters-right-modal" id="rentersright-modal">
        <Modal.Header closeButton>
           <h3>Get Your Compliance Check</h3>
        </Modal.Header>

        <Modal.Body>
          <RentersRightBillForm />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}
export default StaticRenterBlock

